import { getBriefPathValue } from './briefPathUtils';

export function isEmptyOrUnknownFactValue(value) {
  const v = String(value ?? '').trim();
  return !v || /^(unknown|undefined|null)$/i.test(v);
}

/** Mirrors publishHandlers isActionableFact: panel rows the owner can confirm. */
export function isActionableFactForUi(fact, brief) {
  const v = String(fact?.value ?? '').trim();
  if (!fact?.path || !v || /^(unknown|undefined|null)$/i.test(v)) return false;
  if (!brief || typeof brief !== 'object') return true;
  const current = getBriefPathValue(brief, fact.path);
  if (current === undefined || current === null || String(current).trim() === '') return false;
  return true;
}

export function faqIndexFromPath(path) {
  const m = /^faqs\[(\d+)\]/.exec(path || '');
  return m ? Number(m[1]) : null;
}

/** One row per path; drop unknown/empty values and facts cleared in the brief. */
export function factsForPanel(rawFacts, brief) {
  const seen = new Set();
  const out = [];
  for (const fact of rawFacts || []) {
    if (!fact?.path || seen.has(fact.path)) continue;
    if (!isActionableFactForUi(fact, brief)) continue;
    seen.add(fact.path);
    out.push(fact);
  }
  return out;
}

/** FAQs count as one fact per question+answer pair. */
export function countFactsForUi(rawFacts, brief) {
  const facts = factsForPanel(rawFacts, brief);
  const faqIndices = new Set();
  let count = 0;
  for (const fact of facts) {
    const idx = faqIndexFromPath(fact.path);
    if (idx !== null) faqIndices.add(idx);
    else count += 1;
  }
  return count + faqIndices.size;
}

/** FAQ rows count as confirmed only when both question and answer paths are confirmed. */
export function isFactConfirmedForUi(fact, confirmedPaths) {
  const confirmed = new Set(confirmedPaths || []);
  const idx = faqIndexFromPath(fact.path);
  if (idx !== null) {
    return confirmed.has(`faqs[${idx}].question`) && confirmed.has(`faqs[${idx}].answer`);
  }
  return confirmed.has(fact.path);
}

export function countConfirmedForUi(rawFacts, confirmedPaths, brief) {
  const facts = factsForPanel(rawFacts, brief);
  const confirmed = new Set(confirmedPaths || []);
  let count = 0;
  const faqIndices = new Set();
  for (const fact of facts) {
    const idx = faqIndexFromPath(fact.path);
    if (idx !== null) faqIndices.add(idx);
    else if (confirmed.has(fact.path)) count += 1;
  }
  for (const idx of faqIndices) {
    if (confirmed.has(`faqs[${idx}].question`) && confirmed.has(`faqs[${idx}].answer`)) {
      count += 1;
    }
  }
  return count;
}
